import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useCurrentUser() {
  const { data: user, isLoading } = useQuery({
    queryKey: ["current-user"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      return user ?? null;
    },
    staleTime: 0,
  });

  return {
    user: user ?? null,
    userId: user?.id ?? null,
    isLoading,
    isLoggedIn: !!user,
  };
}
